export default __webpack_public_path__ + "static/media/Yellow Spring wreath.38b7c8ff.jpg";